import { ArrowUpRight } from "lucide-react";

const Contact = () => (
  <section id="contact" className="scroll-mt-16 border-t border-line py-24">
    <div className="mx-auto max-w-6xl px-6 text-center">
      <p className="font-mono text-xs uppercase tracking-widest text-muted">
        Contact
      </p>
      <h2 className="mt-3 text-3xl font-semibold tracking-tight md:text-4xl">
        Have something worth building?
      </h2>
      <p className="mx-auto mt-4 max-w-md text-muted">
        We take on a small number of client engagements at a time. Tell us what
        you&rsquo;re working on.
      </p>
      <a
        href="mailto:hello@techlyft.com"
        className="group mt-10 inline-flex items-center gap-3 rounded-lg border border-line bg-surface px-8 py-4 font-mono text-lg transition-colors hover:border-accent/40 hover:text-accent"
      >
        hello@techlyft.com
        <ArrowUpRight className="h-5 w-5 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
      </a>
    </div>
  </section>
);

export default Contact;
